import FooterFactory from '../../factories/footer-factory';
import { TFooterLayoutItem } from '../../types/layout/footer';

interface IFooterProps {
    layout: TFooterLayoutItem[];
}

function Footer({ layout }: IFooterProps) {
    return (
        <footer className="main-footer">
            <FooterFactory layout={layout} />
        </footer>
    );
}

export default Footer;
